export const PERSIST_STATE = 'PERSIST_STATE';

export const PersistState = () => ({ type: PERSIST_STATE });
